import localStorage from './local.storage';
import { StorageService } from '../core/storage/services/storage.service';

export const localStorageService = new StorageService(localStorage);
